import React, { useState, useEffect } from "react";
import { AppShell, NavLink, Loader, Divider } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { Link, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { updateTab, uploadData, uploadFile } from "./app/dataActions";
import { getLastUploadedData } from "./services/api";
import { formattedResponse } from "./services/util";

function SidebarLayout({ children }) {
  const [opened] = useDisclosure();
  const [loading, setLoading] = useState(true);
  const currentTab = useSelector((state) => state.currentTab);
  const data = useSelector((state) => state.data);
  const dispatch = useDispatch();
  const location = useLocation();

  const handleTabChange = (label) => {
    dispatch(updateTab(label));
  };

  useEffect(() => {
    if (data.length === 0) {
      setLoading(true); 
      getLastUploadedData()
        .then((data) => {
         // console.log(data)
          dispatch(uploadData(formattedResponse(data).rows));
          dispatch(uploadFile("Last Uploaded File"));
        })
        .catch((error) => {
          console.error('Error fetching last uploaded data:', error);
        })
        .finally(() => {
            setLoading(false);
       });
    }
  }, [data, dispatch, location]);

  return (
    <AppShell
      key={location.pathname}
      navbar={{
        width: 275,
        breakpoint: "sm",
        collapsed: { mobile: !opened },
      }}
      padding="lg"
    >
      <AppShell.Navbar p="md">
        <img
          src="/The_Carter_Center_Logo.svg"
          alt="The Carter Center Logo"
          style={{ alignSelf: "center", width: 150, marginBottom: 15 }}
        />
        <Divider margins={[5, 0]} variant="solid" color="#ddd" />
        <NavLink
          component={Link}
          to="/conflict-resolution-program"
          active={currentTab === "Conflict Resolution Program"}
          label="Conflict Resolution Program"
          onClick={() => handleTabChange("Conflict Resolution Program")}
          variant="filled"
          color="#22378C"
          defaultOpened
        />
        <Divider margins={[5, 0]} variant="solid" color="#ddd" />

        <div style={{ marginLeft: 36 }}>
          <NavLink
            component={Link}
            to="/arizona"
            active={currentTab === "Arizona"}
            label="Arizona"
            onClick={() => handleTabChange("Arizona")}
            variant="filled"
            color="#22378C"
          />
        </div>
        <div style={{ marginLeft: 36 }}>
          <NavLink
            component={Link}
            to="/florida"
            active={currentTab === "Florida"}
            label="Florida"
            onClick={() => handleTabChange("Florida")}
            variant="filled"
            color="#22378C"
          />
        </div>
        <div style={{ marginLeft: 36 }}>
          <NavLink
            component={Link}
            to="/georgia"
            active={currentTab === "Georgia"}
            label="Georgia"
            onClick={() => handleTabChange("Georgia")}
            variant="filled"
            color="#22378C"
          />
        </div>
        <div style={{ marginLeft: 36 }}>
          <NavLink
            component={Link}
            to="/michigan"
            active={currentTab === "Michigan"}
            label="Michigan"
            onClick={() => handleTabChange("Michigan")}
            variant="filled"
            color="#22378C"
          />
        </div>
        <div style={{ marginLeft: 36 }}>
          <NavLink
            component={Link}
            to="/north-carolina"
            active={currentTab === "North Carolina"}
            label="North Carolina"
            onClick={() => handleTabChange("North Carolina")}
            variant="filled"
            color="#22378C"
          />
        </div>
        <div style={{ marginLeft: 36 }}>
          <NavLink
            component={Link}
            to="/wisconsin"
            active={currentTab === "Wisconsin"}
            label="Wisconsin"
            onClick={() => handleTabChange("Wisconsin")}
            variant="filled"
            color="#22378C"
          />
        </div>
        <Divider margins={[5, 0]} variant="solid" color="#ddd" />

        <NavLink
          component={Link}
          to="/democracy-program"
          label="Democracy Program"
          active={currentTab === "Democracy Program"}
          onClick={() => handleTabChange("Democracy Program")}
          variant="filled"
          color="#22378C"
        />
        <Divider margins={[5, 0]} variant="solid" color="#ddd" />

        <NavLink
          component={Link}
          to="/data-table"
          label="Complete Dataset"
          active={currentTab === "Data Table"}
          onClick={() => handleTabChange("Data Table")}
          variant="filled"
          color="#22378C"
        />
        <Divider margins={[5, 0]} variant="solid" color="#ddd" />
        <div style={{ marginTop: "auto " }}>
          <Divider margins={[5, 0]} variant="solid" color="#ddd" />
          <NavLink
            component={Link}
            to="/file-uploader"
            label="File Upload"
            active={currentTab === "File Upload"}
            onClick={() => handleTabChange("File Upload")}
            variant="filled"
            color="#22378C"
          />
        </div>

        <Divider margins={[5, 0]} variant="solid" color="#ddd" />

        <img
          src="/LG_Root_Change_FinalLogo.png"
          alt="Root Change Logo"
          style={{
            alignSelf: "center",
            width: 100,
            marginTop: 15,
            marginBottom: 5,
          }}
        />
      </AppShell.Navbar>
      <AppShell.Main>
        {loading ? (
          <Loader color="#22378C" size={48} style={{ margin: "auto" }} />
        ) : (
          children
        )}
      </AppShell.Main>
    </AppShell>
  );
}

export default SidebarLayout;
